import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import useTranslation from '@hooks/useTranslation';

import type { IAiRecommendations } from '@model/aiRecommendations';

import { apiClient } from '@services/apiClient';

import { actionItemRecommendationsSelect } from '../helpers/actionItemRecommendationsSelect';

export const actionItemRecommendationsKey = (actionItemId: string | number) => [
  'actionItemRecommendations',
  +actionItemId,
];

export const actionItemRecommendationsFn = (
  queryKey: ReturnType<typeof actionItemRecommendationsKey>,
  signal: AbortSignal | undefined,
) =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/${queryKey[1]}/recommendations`, {
    signal,
  });

export const useActionItemRecommendationsQuery = ({ actionItemId }: { actionItemId: string | number }) => {
  const { t } = useTranslation();

  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: actionItemRecommendationsKey(actionItemId),
    queryFn: ({ queryKey, signal }: QueryFunctionContext<ReturnType<typeof actionItemRecommendationsKey>>) =>
      actionItemRecommendationsFn(queryKey, signal),
    enabled: !!actionItemId && actionItemId !== 'onboarding',
    useErrorBoundary: true,
    cacheTime: 1000,
    select: ({ data }: AxiosResponse<{ data: IAiRecommendations[] }>) =>
      actionItemRecommendationsSelect(data?.data || [], t),
    placeholderData: {
      data: {
        data: [],
      },
    },
  });
};
